/* global jQuery */
import React from 'react'
import { Input, Button, Textarea, Recaptcha } from '../../common'
import { isLibraryLoaded } from '../../../lib/utils/common'

export default class CommentaryFeedback extends React.Component {
  constructor() {
    super()
    this._onChange = this._onChange.bind(this)
    this._validate = this._validate.bind(this)
    this._onChangeRecaptcha = this._onChangeRecaptcha.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.reset = this.reset.bind(this)
    this.state = {
      values : {},
      errors : {},
      invalidFields : true
    }
  }

  getUserDetails() {
    isLibraryLoaded({
      namespace: 'DisneyID',
      callback: () => {
        window.DisneyID.get().getGuest().done((guest = {}) => {
          const profile = guest.profile || {}
          const { firstName = '', lastName = '', email = '' } = profile
          const name = `${firstName} ${lastName}`

          this.setState({
            values : {
              name,
              email
            }
          })
        })
      }
    })
  }

  reset() {
    const { status : { SUCCESS } = {} } = this.props

    if (SUCCESS === true) {
      this.setState({
        values : {},
        errors : {},
        invalidFields : true
      })
      this.refs.recaptcha.reset()
      this.getUserDetails()
    }
  }

  componentDidMount() {
    try {
      this.getUserDetails()

      jQuery('#form--commentary #submit_btn .button__ripple')
        .on('webkitAnimationEnd oanimationend oAnimationEnd msAnimationEnd animationend', () => {
          this.reset()
        })
    } catch(err) { console.error(err) }
  }

  _updateValue(name, value) {
    let values = this.state.values
    const invalidFields = jQuery('#form--commentary').find(':invalid').length > 0

    value = value.replace(/^\s+/, '')

    values = Object.assign({}, values, {
      [name] : value
    })

    this.setState({ values, invalidFields })
  }

  _onChange(ev) {
    const input = ev.target

    this._updateValue(input.name, input.value)
  }

  _onChangeRecaptcha(value) {
    this._updateValue('g-recaptcha-response', value)
  }

  _validate(ev) {
    const input = ev.target
    let inputErr = null
    let errors = this.state.errors

    if (input.checkValidity() === false) {
      inputErr = input.validationMessage
    }

    errors = Object.assign({}, errors, {
      [input.name] : inputErr
    })

    this.setState({ errors })
  }

  handleSubmit(e) {
    e.preventDefault()
    const { values } = this.state
    const { gameId } = this.props
    const regex = /(<([^>]+)>)/ig
    let { name = '', text = '',email = '', ...rest } = values

    if (typeof name === 'string') { 
      name = name.replace(regex,'') 
    }
    if (typeof email === 'string') {
      email = email.toLowerCase()
    }
    if (typeof text === 'string') {
      text = text.replace(regex,'') 
    }

    this.props.postCommentryFeedback({ name, text,email, ...rest, object_id : gameId })
  }

  render() {
    const { invalidFields, values, errors } = this.state
    const { status : { SUBMITTING, SUCCESS, ERROR } = {}, isUpdatesOnly } = this.props
    // UpdatesOnly matches doesnt need CommentaryFeedback.
    if(isUpdatesOnly) {
      return null
    }

    return (
      <article className="sub-module commentary__feedback">
          <header className="bordered">
             <h1>Commentary Feedback</h1>
          </header>
          <div className="content">
              <form className="form form--commentary" id="form--commentary" onSubmit={this.handleSubmit}>
                <div className="form__container">
                  <Input
                    key="nm"
                    groupClass="form__group--commentary"
                    values={values}
                    errors={errors}
                    input={{ type : 'text', id : 'name', name : 'name', label : 'Name', required : true, tabIndex : 1, onChange : this._onChange, onBlur : this._validate }}/>
                  <Input
                    key="em"
                    groupClass="form__group--commentary"
                    values={values}
                    errors={errors}
                    input={{ type : 'email', id : 'email', name : 'email', label : 'Email', required : true, tabIndex : 2, pattern: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', onChange : this._onChange, onBlur : this._validate }}/>
                </div>
                <Textarea
                  key="msg"
                  groupClass="form__group--commentary"
                  showLabel={true}
                  values={values}
                  errors={errors}
                  input={{ id : 'form__message', name : 'text', label : 'All feedback is read by us but only a small number are published.', required : true, tabIndex : 3, row : 3, placeholder: 'Your Message (500 words)', onChange : this._onChange, onBlur : this._validate, maxLength : 500 }}/>
                <Recaptcha
                  key="rc"
                  groupClass="form__group--commentary commentary__captcha"
                  ref="recaptcha"
                  sitekey="6Lc66xIUAAAAAE6RRx2s2GO01aCRx_QGBTXrDiXZ"
                  tabindex={4}
                  onChange={this._onChangeRecaptcha}/>
                <Button
                  id="submit_btn"
                  groupClass="commentary__button"
                  tabindex={5}
                  disabled={invalidFields || ERROR}
                  submitting={SUBMITTING}
                  success={SUCCESS} />
              </form>
          </div>
      </article>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/CommentaryFeedback.jsx
 **/